import { Box } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import * as styles from "./overviewHeaderStyles";

const Header: React.FC = () => {
    return (
        <Box sx={styles.headerStyles}>
            <Box component={RouterLink} to="/" sx={styles.logoLinkStyles}>
                <Box
                    component="img"
                    sx={styles.logoStyles}
                    alt="HSV-NXP Partnerschaftslogo"
                    src="images/illustrations/hsv-nxp-collab.svg"
                />
            </Box>
        </Box>
    );
};

export default Header;
